import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { copy } from "@aasaan-share/ui-contract";
import { viewerModel } from "../viewer-store.ts";
import AdmissionView from "./AdmissionView.svelte";
import GalleryGrid from "./GalleryGrid.svelte";
import Icon from "./Icon.svelte";
import PhotoDialog from "./PhotoDialog.svelte";
import StatusBand from "./StatusBand.svelte";
import VideoDialog from "./VideoDialog.svelte";

var root = $.from_html(`<div><span class="opening-block opening-media-block"></span></div>`);
var root_1 = $.from_html(`<div class="viewer-layout opening-shell"><aside aria-hidden="true" class="share-rail opening-rail"><span class="opening-block opening-rail-label"></span> <span class="opening-block opening-rail-item"></span> <span class="opening-block opening-rail-item"></span></aside> <div class="viewer-column"><header class="app-header"><div class="brand"><img alt="AasaanShare" class="brand-wordmark" height="38" src="/assets/logo-wordmark.svg" width="123"/></div> <span aria-hidden="true" class="opening-block opening-switcher"></span></header> <div data-status-slot=""><!></div> <main aria-busy="true" class="gallery-main" id="main-content"><header class="gallery-heading"><p class="eyebrow">Shared album</p> <h1>Shared photos</h1> <div aria-hidden="true" class="gallery-heading-meta"><span class="opening-block opening-count"></span></div></header> <p class="sr-only" role="status">Preparing shared photos</p> <div aria-hidden="true" class="gallery-grid opening-grid"></div></main></div></div>`);
var root_2 = $.from_html(`<li><button class="share-link" data-action="select-share" type="button"><span class="share-link-title"> </span> <span class="share-link-count"> </span></button></li>`);
var root_3 = $.from_html(`<a aria-label="Back to account dashboard" class="account-dashboard-link"><span aria-hidden="true">←</span> <span>Dashboard</span></a>`);
var root_4 = $.from_html(`<img alt=""/>`);
var root_5 = $.from_html(`<a class="account-identity"><span aria-hidden="true" class="account-avatar"><!></span> <span class="account-name"> </span></a>`);
var root_6 = $.from_html(`<span class="owner-identity"><span aria-hidden="true" class="owner-avatar"><!></span> <span class="owner-name"> </span></span>`);
var root_7 = $.from_html(`<button class="switcher-option" data-action="select-share" role="menuitemradio" type="button"> </button>`);
var root_8 = $.from_html(`<div class="switcher-sheet" role="menu"></div>`);
var root_9 = $.from_html(`<section aria-labelledby="revoked-title" class="revoked-band"><h2 id="revoked-title"> </h2> <p>Your other shared albums are still here.</p> <button class="secondary-button" data-action="focus-shares" type="button">See other albums</button></section>`);
var root_10 = $.from_html(`<p class="album-owner"> </p>`);
var root_11 = $.from_html(`<p aria-live="polite" class="album-download-status" role="status"> </p>`);
var root_12 = $.from_html(`<div aria-valuemax="100" aria-valuemin="0" class="progress-track album-download-progress" role="progressbar"><span></span></div>`);
var root_13 = $.from_html(`<button class="secondary-button" data-action="cancel-album-download" type="button"> </button>`);
var root_14 = $.from_html(`<button aria-label="Download all" class="primary-button" data-action="download-all" title="Download all originals" type="button"><!> <span class="action-label-full"> </span> <span class="action-label-compact">Download</span></button>`);
var root_15 = $.from_html(`<div class="album-download-control"><!> <!> <!></div> <button class="secondary-button selection-mode-button" type="button"><!> <span class="action-label-full"> </span> <span class="action-label-compact"> </span></button>`, 1);
var root_16 = $.from_html(`<span aria-hidden="true" class="button-spinner"></span>`);
var root_17 = $.from_html(`<p role="status"> </p>`);
var root_18 = $.from_html(`<div class="contribution-action"><input data-contribution-input="" hidden="" multiple="" type="file"/> <button class="primary-button contribution-button" data-action="add-photos" type="button"><!> <span class="action-label-full"> </span> <span class="action-label-compact">Add</span></button> <!></div>`);
var root_19 = $.from_html(`<div class="gallery-actions"><!> <!></div>`);
var root_20 = $.from_html(`<button class="collaborator-chip" data-action="filter-collaborator" data-collaborator-id="original" type="button"><span aria-hidden="true" class="collaborator-chip-avatar"><!></span> <span> </span> <span class="collaborator-chip-count"> </span></button>`);
var root_21 = $.from_html(`<button class="collaborator-chip" data-action="filter-collaborator" type="button"><span aria-hidden="true" class="collaborator-chip-avatar"><!></span> <span> </span> <span class="collaborator-chip-count"> </span></button>`);
var root_22 = $.from_html(`<section aria-label="Album collaborators" class="collaboration-tools"><div class="collaborator-filter"><p class="collaborator-filter-label">Filter by contributor</p> <div class="collaborator-chips"><button class="collaborator-chip" data-action="filter-collaborator" data-collaborator-id="all" type="button"><span aria-hidden="true" class="collaborator-chip-avatar">A</span> <span>All</span> <span class="collaborator-chip-count"> </span></button> <!> <!></div></div></section>`);
var root_23 = $.from_html(`<div class="gallery-load-more gallery-load-more-top"><button class="secondary-button" data-action="load-more" type="button"><!> </button></div>`);
var root_24 = $.from_html(`<div class="gallery-load-more gallery-load-more-bottom"><button class="secondary-button" data-action="load-more" type="button"><!> </button></div>`);
var root_25 = $.from_html(`<div class="photo-selection-download"><button aria-live="polite" class="primary-button" data-action="download-selected-photos" type="button"><!> </button></div>`);
var root_26 = $.from_html(`<div class="viewer-layout"><nav aria-label="Shared albums" class="share-rail"><p class="rail-label">Your albums</p> <ul class="share-list"></ul></nav> <div class="viewer-column"><header class="app-header"><div class="header-primary"><div class="header-navigation"><!> <div class="brand"><img alt="AasaanShare" class="brand-wordmark" height="38" src="/assets/logo-wordmark.svg" width="123"/></div></div> <!></div> <div class="share-switcher"><button class="switcher-button" data-action="toggle-shares" type="button"><!> <span><span class="switcher-label">Current album</span> <span class="switcher-title"> </span></span></button> <!></div></header> <div data-status-slot=""><!></div> <!> <main class="gallery-main" id="main-content"><header class="gallery-heading"><p class="eyebrow">Shared album</p> <h1> </h1> <!> <div class="gallery-heading-meta"><div class="gallery-summary"><span class="access-chip"><span class="access-label-full"> </span> <span aria-hidden="true" class="access-label-compact"> </span></span> <p class="gallery-count"> </p></div> <div class="media-sort-controls"><label class="media-sort-control"><span>Sort</span> <select aria-label="Sort album media" data-action="sort-media"><option>Added to album</option><option>Media created</option></select></label> <button class="icon-button media-sort-direction" data-action="toggle-media-sort-direction" type="button"><!></button></div> <!></div></header> <!> <!> <!> <!> <!></main></div></div> <!>`, 1);
var root_27 = $.from_html(`<div aria-atomic="true" aria-live="polite" class="sr-only" id="announcer"> </div> <!>`, 1);

export default function ViewerRoot($$anchor, $$props) {
	$.push($$props, true);

	const $viewerModel = () => $.store_get(viewerModel, '$viewerModel', $$stores);
	const [$$stores, $$cleanup] = $.setup_stores();
	const openingRatios = [1.45, 0.84, 1.2, 0.9, 1.3, 0.76, 1.1, 0.92];
	let model = $.derived($viewerModel);
	let canShowGallery = $.derived(() => $.get(model) ? galleryAvailable($.get(model)) : false);

	function galleryAvailable(value) {
		return value.mode === "gallery" && value.shares.length > 0 && (value.admission === "connected" || value.admission === "connecting" || value.admission === "reconnecting");
	}

	function ownerNameFromEmail(email) {
		const localPart = email.split("@", 1)[0] ?? "";
		const name = localPart.split(/[._+-]+/).filter(Boolean).map((word) => `${word[0]?.toUpperCase() ?? ""}${word.slice(1)}`).join(" ");

		return name || email;
	}

	function itemLabel(count) {
		return count === 1 ? "item" : "items";
	}

	function galleryCount(loadedCount, totalMediaCount, hasMore) {
		if (totalMediaCount !== undefined) {
			return `${loadedCount} of ${totalMediaCount} ${itemLabel(totalMediaCount)}`;
		}

		return `${loadedCount} ${itemLabel(loadedCount)}${hasMore ? " shown" : ""}`;
	}

	function visibleMedia(share, sort, direction) {
		const visible = share.collaboratorFilter === "all"
			? share.media
			: share.media.filter((media) => share.collaboratorFilter === "original"
				? media.uploadedBy === undefined
				: media.uploadedBy?.recipientId === share.collaboratorFilter);

		if (sort === "added") {
			return direction === "ascending" ? visible : [...visible].reverse();
		}

		return sortMediaByCreation(visible, direction);
	}

	function sortMediaByCreation(media, direction) {
		return media.map((item, index) => ({ createdAt: parseCreatedAt(item.createdAt), index, item })).sort((left, right) => left.createdAt === null
			? right.createdAt === null ? left.index - right.index : 1
			: right.createdAt === null
				? -1
				: (direction === "ascending"
					? left.createdAt - right.createdAt
					: right.createdAt - left.createdAt) || left.index - right.index).map(({ item }) => item);
	}

	function mediaSortDirectionLabel(sort, direction) {
		const current = direction === "ascending" ? "oldest first" : "newest first";
		const next = direction === "ascending" ? "newest first" : "oldest first";
		const subject = sort === "created" ? "media date" : "album order";

		return `Sorted by ${subject}, ${current}. Show ${next}`;
	}

	function parseCreatedAt(value) {
		const timestamp = value ? Date.parse(value) : Number.NaN;

		return Number.isFinite(timestamp) ? timestamp : null;
	}

	function collaboratorInitials(displayName) {
		return displayName.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase() ?? "").join("");
	}

	function contributionLabel(value) {
		if (!value) return "Add media";

		if (value.state === "preparing") {
			return value.currentItem
				? `Preparing ${value.currentItem} of ${value.totalItems}`
				: "Preparing media";
		}

		if (value.state === "uploading") {
			return `Uploading ${value.currentItem ?? 1} of ${value.totalItems}`;
		}

		if (value.state === "finalizing") return "Finishing upload";

		return "Add media";
	}

	function albumDownloadCopy(download) {
		if (download.state === "preparing") return "Preparing all items...";

		if (download.state === "downloading") {
			return `Downloading item ${download.current} of ${download.total} (${Math.round(download.progress * 100)}%)`;
		}

		if (download.state === "completed") {
			return `Downloaded ${download.completed} ${itemLabel(download.completed)}.`;
		}

		if (download.state === "cancelled") return "Album download cancelled.";

		return `Downloaded ${download.completed} of ${download.total} ${itemLabel(download.total)}.`;
	}

	function downloadProgress(download) {
		return Math.round(download.progress * 100);
	}

	function shareItemCount(share) {
		const count = share.totalMediaCount ?? share.media.length;

		return `${count} ${itemLabel(count)}`;
	}

	function tileStyle(ratio) {
		return `--media-ratio:${ratio};--media-basis-desktop:${Math.round(ratio * 260)}px;--media-basis-mobile:${Math.round(ratio * 172)}px`;
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_31 = ($$anchor) => {
			var fragment_1 = root_27();
			var div = $.first_child(fragment_1);
			var text = $.child(div, true);

			$.reset(div);

			var node_1 = $.sibling(div, 2);

			{
				var consequent = ($$anchor) => {
					var div_1 = root_1();
					var div_2 = $.sibling($.child(div_1), 2);
					var div_3 = $.sibling($.child(div_2), 2);
					var node_2 = $.child(div_3);

					StatusBand(node_2, {
						get admission() {
							return $.get(model).admission;
						},

						get transferState() {
							return $.get(model).transferState;
						}
					});

					$.reset(div_3);

					var main = $.sibling(div_3, 2);
					var div_4 = $.sibling($.child(main), 4);

					$.each(div_4, 21, () => openingRatios, $.index, ($$anchor, ratio) => {
						var div_5 = root();
						let classes;

						$.template_effect(
							($0) => {
								classes = $.set_class(div_5, 1, 'media-item opening-media-item', null, classes, { 'media-item-wide': $.get(ratio) >= 1.3 });
								$.set_style(div_5, $0);
							},
							[() => tileStyle($.get(ratio))]
						);

						$.append($$anchor, div_5);
					});

					$.reset(div_4);
					$.reset(main);
					$.reset(div_2);
					$.reset(div_1);
					$.append($$anchor, div_1);
				};

				var consequent_1 = ($$anchor) => {
					AdmissionView($$anchor, {
						get model() {
							return $.get(model);
						}
					});
				};

				var alternate_5 = ($$anchor) => {
					const selected = $.derived(() => $.get(model).shares.find((share) => share.id === $.get(model).selectedShareId) ?? $.get(model).shares[0]);
					var fragment_3 = $.comment();
					var node_3 = $.first_child(fragment_3);

					{
						var consequent_30 = ($$anchor) => {
							const galleryMedia = $.derived(() => visibleMedia($.get(selected), $.get(model).mediaSort, $.get(model).mediaSortDirection));
							const photoSelectionActive = $.derived(() => $.get(selected).access === "download" && $.get(model).photoSelectionActive === true);
							const selectedPhotoIds = $.derived(() => $.get(model).selectedPhotoIds ?? []);
							const downloadableOriginalCount = $.derived(() => $.get(selected).media.filter((media) => media.canDownloadOriginal).length);
							const selectedMedia = $.derived(() => $.get(selected).media.find((media) => media.id === $.get(model).selectedMediaId));

							const ownerName = $.derived(() => $.get(selected).ownerUsername ?? ($.get(selected).ownerEmail
								? ownerNameFromEmail($.get(selected).ownerEmail)
								: "Original album"));

							const accountName = $.derived(() => $.get(model).account?.displayName ?? $.get(model).account?.username);
							var fragment_4 = root_26();
							var div_6 = $.first_child(fragment_4);
							var nav = $.child(div_6);
							var ul = $.sibling($.child(nav), 2);

							$.each(ul, 21, () => $.get(model).shares, (share) => share.id, ($$anchor, share) => {
								var li = root_2();
								var button = $.child(li);
								var span = $.child(button);
								var text_1 = $.child(span, true);

								$.reset(span);

								var span_1 = $.sibling(span, 2);
								var text_2 = $.child(span_1, true);

								$.reset(span_1);
								$.reset(button);
								$.reset(li);

								$.template_effect(
									($0) => {
										$.set_attribute(button, 'aria-current', $.get(share).id === $.get(selected).id ? "page" : undefined);
										$.set_attribute(button, 'data-share-id', $.get(share).id);
										$.set_text(text_1, $.get(share).label);
										$.set_text(text_2, $0);
									},
									[() => shareItemCount($.get(share))]
								);

								$.append($$anchor, li);
							});

							$.reset(ul);
							$.reset(nav);

							var div_7 = $.sibling(nav, 2);
							var header = $.child(div_7);
							var div_8 = $.child(header);
							var div_9 = $.child(div_8);
							var node_4 = $.child(div_9);

							{
								var consequent_2 = ($$anchor) => {
									var a = root_3();

									$.template_effect(() => $.set_attribute(a, 'href', $.get(model).accountDashboardUrl));
									$.append($$anchor, a);
								};

								$.if(node_4, ($$render) => {
									if ($.get(model).accountDashboardUrl) $$render(consequent_2);
								});
							}

							$.next(2);
							$.reset(div_9);

							var node_5 = $.sibling(div_9, 2);

							{
								var consequent_4 = ($$anchor) => {
									var a_1 = root_5();
									var span_2 = $.child(a_1);
									var node_6 = $.child(span_2);

									{
										var consequent_3 = ($$anchor) => {
											var img = root_4();

											$.template_effect(() => $.set_attribute(img, 'src', $.get(model).account.avatarUrl));
											$.append($$anchor, img);
										};

										var alternate = ($$anchor) => {
											var text_3 = $.text();

											$.template_effect(($0) => $.set_text(text_3, $0), [() => collaboratorInitials($.get(accountName))]);
											$.append($$anchor, text_3);
										};

										$.if(node_6, ($$render) => {
											if ($.get(model).account?.avatarUrl) $$render(consequent_3); else $$render(alternate, -1);
										});
									}

									$.reset(span_2);

									var span_3 = $.sibling(span_2, 2);
									var text_4 = $.child(span_3, true);

									$.reset(span_3);
									$.reset(a_1);

									$.template_effect(() => {
										$.set_attribute(a_1, 'aria-label', `Signed in as ${$.get(accountName)}`);
										$.set_attribute(a_1, 'href', $.get(model).accountDashboardUrl ?? "/account");
										$.set_text(text_4, $.get(accountName));
									});

									$.append($$anchor, a_1);
								};

								var consequent_6 = ($$anchor) => {
									var span_4 = root_6();
									var span_5 = $.child(span_4);
									var node_7 = $.child(span_5);

									{
										var consequent_5 = ($$anchor) => {
											var img_1 = root_4();

											$.template_effect(() => $.set_attribute(img_1, 'src', $.get(selected).ownerAvatarUrl));
											$.append($$anchor, img_1);
										};

										var alternate_1 = ($$anchor) => {
											var text_5 = $.text();

											$.template_effect(($0) => $.set_text(text_5, $0), [() => collaboratorInitials($.get(ownerName))]);
											$.append($$anchor, text_5);
										};

										$.if(node_7, ($$render) => {
											if ($.get(selected).ownerAvatarUrl) $$render(consequent_5); else $$render(alternate_1, -1);
										});
									}

									$.reset(span_5);

									var span_6 = $.sibling(span_5, 2);
									var text_6 = $.child(span_6, true);

									$.reset(span_6);
									$.reset(span_4);

									$.template_effect(() => {
										$.set_attribute(span_4, 'aria-label', `Shared by ${$.get(ownerName)}`);
										$.set_text(text_6, $.get(ownerName));
									});

									$.append($$anchor, span_4);
								};

								$.if(node_5, ($$render) => {
									if ($.get(accountName)) $$render(consequent_4); else if ($.get(selected).ownerUsername || $.get(selected).ownerEmail) $$render(consequent_6, 1);
								});
							}

							$.reset(div_8);

							var div_10 = $.sibling(div_8, 2);
							var button_1 = $.child(div_10);
							var node_8 = $.child(button_1);

							Icon(node_8, { name: 'menu' });

							var span_7 = $.sibling(node_8, 2);
							var span_8 = $.sibling($.child(span_7), 2);
							var text_7 = $.child(span_8, true);

							$.reset(span_8);
							$.reset(span_7);
							$.reset(button_1);

							var node_9 = $.sibling(button_1, 2);

							{
								var consequent_7 = ($$anchor) => {
									var div_11 = root_8();

									$.each(div_11, 21, () => $.get(model).shares, (share) => share.id, ($$anchor, share) => {
										var button_2 = root_7();
										var text_8 = $.child(button_2, true);

										$.reset(button_2);

										$.template_effect(
											($0) => {
												$.set_attribute(button_2, 'aria-checked', $0);
												$.set_attribute(button_2, 'data-share-id', $.get(share).id);
												$.set_text(text_8, $.get(share).label);
											},
											[() => String($.get(share).id === $.get(selected).id)]
										);

										$.append($$anchor, button_2);
									});

									$.reset(div_11);
									$.append($$anchor, div_11);
								};

								$.if(node_9, ($$render) => {
									if ($.get(model).shareMenuOpen) $$render(consequent_7);
								});
							}

							$.reset(div_10);
							$.reset(header);

							var div_12 = $.sibling(header, 2);
							var node_10 = $.child(div_12);

							StatusBand(node_10, {
								get admission() {
									return $.get(model).admission;
								},

								get transferState() {
									return $.get(model).transferState;
								}
							});

							$.reset(div_12);

							var node_11 = $.sibling(div_12, 2);

							{
								var consequent_8 = ($$anchor) => {
									var section = root_9();
									var h2 = $.child(section);
									var text_9 = $.child(h2);

									$.reset(h2);
									$.next(4);
									$.reset(section);
									$.template_effect(() => $.set_text(text_9, `${$.get(model).revokedShareLabel ?? ''} is no longer available`));
									$.append($$anchor, section);
								};

								$.if(node_11, ($$render) => {
									if ($.get(model).revokedShareLabel) $$render(consequent_8);
								});
							}

							var main_1 = $.sibling(node_11, 2);
							var header_1 = $.child(main_1);
							var h1 = $.sibling($.child(header_1), 2);
							var text_10 = $.child(h1, true);

							$.reset(h1);

							var node_12 = $.sibling(h1, 2);

							{
								var consequent_9 = ($$anchor) => {
									var p = root_10();
									var text_11 = $.child(p);

									$.reset(p);
									$.template_effect(() => $.set_text(text_11, `Shared by ${$.get(ownerName) ?? ''}`));
									$.append($$anchor, p);
								};

								$.if(node_12, ($$render) => {
									if ($.get(accountName)) $$render(consequent_9);
								});
							}

							var div_13 = $.sibling(node_12, 2);
							var div_14 = $.child(div_13);
							var span_9 = $.child(div_14);
							var span_10 = $.child(span_9);
							var text_12 = $.child(span_10, true);

							$.reset(span_10);

							var span_11 = $.sibling(span_10, 2);
							var text_13 = $.child(span_11, true);

							$.reset(span_11);
							$.reset(span_9);

							var p_1 = $.sibling(span_9, 2);
							var text_14 = $.child(p_1, true);

							$.reset(p_1);
							$.reset(div_14);

							var div_15 = $.sibling(div_14, 2);
							var label = $.child(div_15);
							var select = $.sibling($.child(label), 2);
							var option = $.child(select);

							option.value = option.__value = 'added';

							var option_1 = $.sibling(option);

							option_1.value = option_1.__value = 'created';
							$.reset(select);

							var select_value;

							$.init_select(select);
							$.reset(label);

							var button_3 = $.sibling(label, 2);
							var node_13 = $.child(button_3);

							{
								let $0 = $.derived(() => $.get(model).mediaSortDirection === "ascending" ? "sortAscending" : "sortDescending");

								Icon(node_13, {
									get name() {
										return $.get($0);
									}
								});
							}

							$.reset(button_3);
							$.reset(div_15);

							var node_14 = $.sibling(div_15, 2);

							{
								var consequent_18 = ($$anchor) => {
									var div_16 = root_19();
									var node_15 = $.child(div_16);

									{
										var consequent_14 = ($$anchor) => {
											var fragment_7 = root_15();
											var div_17 = $.first_child(fragment_7);
											var node_16 = $.child(div_17);

											{
												var consequent_10 = ($$anchor) => {
													var p_2 = root_11();
													var text_15 = $.child(p_2, true);

													$.reset(p_2);

													$.template_effect(
														($0) => {
															$.set_attribute(p_2, 'data-album-download', $.get(model).albumDownload.state);
															$.set_text(text_15, $0);
														},
														[() => albumDownloadCopy($.get(model).albumDownload)]
													);

													$.append($$anchor, p_2);
												};

												$.if(node_16, ($$render) => {
													if ($.get(model).albumDownload) $$render(consequent_10);
												});
											}

											var node_17 = $.sibling(node_16, 2);

											{
												var consequent_11 = ($$anchor) => {
													const progress = $.derived(() => downloadProgress($.get(model).albumDownload));
													var div_18 = root_12();
													var span_12 = $.child(div_18);

													$.reset(div_18);

													$.template_effect(
														($0) => {
															$.set_attribute(div_18, 'aria-label', `Current download ${$.get(progress)}%`);
															$.set_attribute(div_18, 'aria-valuenow', $0);
															$.set_style(span_12, `width:${$.get(progress)}%`);
														},
														[() => String($.get(progress))]
													);

													$.append($$anchor, div_18);
												};

												$.if(node_17, ($$render) => {
													if ($.get(model).albumDownload?.state === "downloading") $$render(consequent_11);
												});
											}

											var node_18 = $.sibling(node_17, 2);

											{
												var consequent_12 = ($$anchor) => {
													var button_4 = root_13();
													var text_16 = $.child(button_4, true);

													$.reset(button_4);
													$.template_effect(() => $.set_text(text_16, copy["action.cancel"]));
													$.append($$anchor, button_4);
												};

												var consequent_13 = ($$anchor) => {
													var button_5 = root_14();
													var node_19 = $.child(button_5);

													Icon(node_19, { name: 'download' });

													var span_13 = $.sibling(node_19, 2);
													var text_17 = $.child(span_13, true);

													$.reset(span_13);
													$.next(2);
													$.reset(button_5);

													$.template_effect(() => $.set_text(text_17, $.get(downloadableOriginalCount) === 1
														? "Download 1 original"
														: `Download ${$.get(downloadableOriginalCount)} originals`));

													$.append($$anchor, button_5);
												};

												$.if(node_18, ($$render) => {
													if ($.get(model).albumDownload?.state === "preparing" || $.get(model).albumDownload?.state === "downloading") $$render(consequent_12); else if (!$.get(photoSelectionActive) && $.get(downloadableOriginalCount) > 0) $$render(consequent_13, 1);
												});
											}

											$.reset(div_17);

											var button_6 = $.sibling(div_17, 2);
											var node_20 = $.child(button_6);

											{
												let $0 = $.derived(() => $.get(photoSelectionActive) ? "close" : "select");

												Icon(node_20, {
													get name() {
														return $.get($0);
													}
												});
											}

											var span_14 = $.sibling(node_20, 2);
											var text_18 = $.child(span_14, true);

											$.reset(span_14);

											var span_15 = $.sibling(span_14, 2);
											var text_19 = $.child(span_15, true);

											$.reset(span_15);
											$.reset(button_6);

											$.template_effect(() => {
												$.set_attribute(button_6, 'aria-label', $.get(photoSelectionActive) ? "Cancel photo selection" : "Select photos");
												$.set_attribute(button_6, 'data-action', $.get(photoSelectionActive) ? "cancel-photo-selection" : "select-photos");
												$.set_attribute(button_6, 'title', $.get(photoSelectionActive) ? "Cancel photo selection" : "Select photos");
												$.set_text(text_18, $.get(photoSelectionActive) ? "Cancel selection" : "Select photos");
												$.set_text(text_19, $.get(photoSelectionActive) ? "Cancel" : "Select");
											});

											$.append($$anchor, fragment_7);
										};

										$.if(node_15, ($$render) => {
											if ($.get(selected).access === "download" && $.get(selected).media.length > 0) $$render(consequent_14);
										});
									}

									var node_21 = $.sibling(node_15, 2);

									{
										var consequent_17 = ($$anchor) => {
											const contributionActive = $.derived(() => $.get(model).contribution?.state === "preparing" || $.get(model).contribution?.state === "uploading" || $.get(model).contribution?.state === "finalizing");
											var div_19 = root_18();
											var input = $.child(div_19);
											var button_7 = $.sibling(input, 2);
											var node_22 = $.child(button_7);

											{
												var consequent_15 = ($$anchor) => {
													var span_16 = root_16();

													$.append($$anchor, span_16);
												};

												var alternate_2 = ($$anchor) => {
													Icon($$anchor, { name: 'upload' });
												};

												$.if(node_22, ($$render) => {
													if ($.get(contributionActive)) $$render(consequent_15); else $$render(alternate_2, -1);
												});
											}

											var span_17 = $.sibling(node_22, 2);
											var text_20 = $.child(span_17, true);

											$.reset(span_17);
											$.next(2);
											$.reset(button_7);

											var node_23 = $.sibling(button_7, 2);

											{
												var consequent_16 = ($$anchor) => {
													var p_3 = root_17();
													let classes_1;
													var text_21 = $.child(p_3, true);

													$.reset(p_3);

													$.template_effect(() => {
														classes_1 = $.set_class(p_3, 1, 'contribution-message', null, classes_1, {
															'contribution-error': $.get(model).contribution.state === "failed"
														});

														$.set_text(text_21, $.get(model).contribution.message);
													});

													$.append($$anchor, p_3);
												};

												$.if(node_23, ($$render) => {
													if ($.get(model).contribution?.message) $$render(consequent_16);
												});
											}

											$.reset(div_19);

											$.template_effect(
												($0, $1, $2) => {
													$.set_attribute(input, 'accept', $.get(model).videoCapability === "testing"
														? "image/avif,image/jpeg,image/png,image/webp,video/mp4"
														: "image/avif,image/jpeg,image/png,image/webp");

													$.set_attribute(button_7, 'aria-label', $0);
													$.set_attribute(button_7, 'aria-busy', $.get(contributionActive) ? "true" : undefined);
													button_7.disabled = $.get(contributionActive);
													$.set_attribute(button_7, 'title', $1);
													$.set_text(text_20, $2);
												},
												[
													() => contributionLabel($.get(model).contribution),
													() => contributionLabel($.get(model).contribution),
													() => contributionLabel($.get(model).contribution)
												]
											);

											$.append($$anchor, div_19);
										};

										$.if(node_21, ($$render) => {
											if ($.get(selected).canContribute) $$render(consequent_17);
										});
									}

									$.reset(div_16);
									$.append($$anchor, div_16);
								};

								$.if(node_14, ($$render) => {
									if ($.get(selected).access === "download" && $.get(selected).media.length > 0 || $.get(selected).canContribute) $$render(consequent_18);
								});
							}

							$.reset(div_13);
							$.reset(header_1);

							var node_24 = $.sibling(header_1, 2);

							{
								var consequent_22 = ($$anchor) => {
									var section_1 = root_22();
									var div_20 = $.child(section_1);
									var div_21 = $.sibling($.child(div_20), 2);
									var button_8 = $.child(div_21);
									var span_18 = $.sibling($.child(button_8), 4);
									var text_22 = $.child(span_18, true);

									$.reset(span_18);
									$.reset(button_8);

									var node_25 = $.sibling(button_8, 2);

									{
										var consequent_20 = ($$anchor) => {
											var button_9 = root_20();
											var span_19 = $.child(button_9);
											var node_26 = $.child(span_19);

											{
												var consequent_19 = ($$anchor) => {
													var img_2 = root_4();

													$.template_effect(() => $.set_attribute(img_2, 'src', $.get(selected).ownerAvatarUrl));
													$.append($$anchor, img_2);
												};

												var alternate_3 = ($$anchor) => {
													var text_23 = $.text();

													$.template_effect(($0) => $.set_text(text_23, $0), [() => collaboratorInitials($.get(ownerName))]);
													$.append($$anchor, text_23);
												};

												$.if(node_26, ($$render) => {
													if ($.get(selected).ownerAvatarUrl) $$render(consequent_19); else $$render(alternate_3, -1);
												});
											}

											$.reset(span_19);

											var span_20 = $.sibling(span_19, 2);
											var text_24 = $.child(span_20, true);

											$.reset(span_20);

											var span_21 = $.sibling(span_20, 2);
											var text_25 = $.child(span_21, true);

											$.reset(span_21);
											$.reset(button_9);

											$.template_effect(
												($0) => {
													$.set_attribute(button_9, 'aria-pressed', $0);
													$.set_text(text_24, $.get(ownerName));
													$.set_text(text_25, $.get(selected).originalMediaCount);
												},
												[
													() => String($.get(selected).collaboratorFilter === "original")
												]
											);

											$.append($$anchor, button_9);
										};

										$.if(node_25, ($$render) => {
											if ($.get(selected).originalMediaCount > 0) $$render(consequent_20);
										});
									}

									var node_27 = $.sibling(node_25, 2);

									$.each(node_27, 17, () => $.get(selected).collaborators, (collaborator) => collaborator.recipientId, ($$anchor, collaborator) => {
										var button_10 = root_21();
										var span_22 = $.child(button_10);
										var node_28 = $.child(span_22);

										{
											var consequent_21 = ($$anchor) => {
												var img_3 = root_4();

												$.template_effect(() => $.set_attribute(img_3, 'src', $.get(collaborator).avatarUrl));
												$.append($$anchor, img_3);
											};

											var alternate_4 = ($$anchor) => {
												var text_26 = $.text();

												$.template_effect(($0) => $.set_text(text_26, $0), [() => collaboratorInitials($.get(collaborator).displayName)]);
												$.append($$anchor, text_26);
											};

											$.if(node_28, ($$render) => {
												if ($.get(collaborator).avatarUrl) $$render(consequent_21); else $$render(alternate_4, -1);
											});
										}

										$.reset(span_22);

										var span_23 = $.sibling(span_22, 2);
										var text_27 = $.child(span_23, true);

										$.reset(span_23);

										var span_24 = $.sibling(span_23, 2);
										var text_28 = $.child(span_24, true);

										$.reset(span_24);
										$.reset(button_10);

										$.template_effect(
											($0) => {
												$.set_attribute(button_10, 'aria-pressed', $0);
												$.set_attribute(button_10, 'data-collaborator-id', $.get(collaborator).recipientId);
												$.set_text(text_27, $.get(collaborator).displayName);
												$.set_text(text_28, $.get(collaborator).count);
											},
											[
												() => String($.get(selected).collaboratorFilter === $.get(collaborator).recipientId)
											]
										);

										$.append($$anchor, button_10);
									});

									$.reset(div_21);
									$.reset(div_20);
									$.reset(section_1);

									$.template_effect(
										($0) => {
											$.set_attribute(button_8, 'aria-pressed', $0);
											$.set_text(text_22, $.get(selected).totalMediaCount ?? $.get(selected).media.length);
										},
										[() => String($.get(selected).collaboratorFilter === "all")]
									);

									$.append($$anchor, section_1);
								};

								$.if(node_24, ($$render) => {
									if ($.get(selected).collaborators.length > 0) $$render(consequent_22);
								});
							}

							var node_29 = $.sibling(node_24, 2);

							{
								var consequent_24 = ($$anchor) => {
									var div_22 = root_23();
									var button_11 = $.child(div_22);
									var node_30 = $.child(button_11);

									{
										var consequent_23 = ($$anchor) => {
											var span_25 = root_16();

											$.append($$anchor, span_25);
										};

										$.if(node_30, ($$render) => {
											if ($.get(selected).loadingMore) $$render(consequent_23);
										});
									}

									var text_29 = $.sibling(node_30);

									$.reset(button_11);
									$.reset(div_22);

									$.template_effect(() => {
										$.set_attribute(button_11, 'aria-busy', $.get(selected).loadingMore ? "true" : undefined);
										button_11.disabled = $.get(selected).loadingMore;
										$.set_text(text_29, ` ${$.get(selected).loadingMore ? "Loading more photos..." : "Load more photos"}`);
									});

									$.append($$anchor, div_22);
								};

								$.if(node_29, ($$render) => {
									if ($.get(selected).hasMore) $$render(consequent_24);
								});
							}

							var node_31 = $.sibling(node_29, 2);

							{
								let $0 = $.derived(() => $.get(model).mediaSort === "created");

								let $1 = $.derived(() => $.get(selected).ownerUsername ?? ($.get(selected).ownerEmail
									? ownerNameFromEmail($.get(selected).ownerEmail)
									: undefined));

								GalleryGrid(node_31, {
									get access() {
										return $.get(selected).access;
									},

									get groupByDate() {
										return $.get($0);
									},

									get media() {
										return $.get(galleryMedia);
									},

									get ownerAvatarUrl() {
										return $.get(selected).ownerAvatarUrl;
									},

									get ownerName() {
										return $.get($1);
									},

									get photoSelectionActive() {
										return $.get(photoSelectionActive);
									},

									get selectedPhotoIds() {
										return $.get(selectedPhotoIds);
									}
								});
							}

							var node_32 = $.sibling(node_31, 2);

							{
								var consequent_26 = ($$anchor) => {
									var div_23 = root_24();
									var button_12 = $.child(div_23);
									var node_33 = $.child(button_12);

									{
										var consequent_25 = ($$anchor) => {
											var span_26 = root_16();

											$.append($$anchor, span_26);
										};

										$.if(node_33, ($$render) => {
											if ($.get(selected).loadingMore) $$render(consequent_25);
										});
									}

									var text_30 = $.sibling(node_33);

									$.reset(button_12);
									$.reset(div_23);

									$.template_effect(() => {
										$.set_attribute(button_12, 'aria-busy', $.get(selected).loadingMore ? "true" : undefined);
										button_12.disabled = $.get(selected).loadingMore;
										$.set_text(text_30, ` ${$.get(selected).loadingMore ? "Loading more photos..." : "Load more photos"}`);
									});

									$.append($$anchor, div_23);
								};

								$.if(node_32, ($$render) => {
									if ($.get(selected).hasMore) $$render(consequent_26);
								});
							}

							var node_34 = $.sibling(node_32, 2);

							{
								var consequent_27 = ($$anchor) => {
									const albumDownloadActive = $.derived(() => $.get(model).albumDownload?.state === "preparing" || $.get(model).albumDownload?.state === "downloading");
									var div_24 = root_25();
									var button_13 = $.child(div_24);
									var node_35 = $.child(button_13);

									Icon(node_35, { name: 'download' });

									var text_31 = $.sibling(node_35);

									$.reset(button_13);
									$.reset(div_24);

									$.template_effect(() => {
										button_13.disabled = $.get(albumDownloadActive) || $.get(selectedPhotoIds).length === 0;

										$.set_text(text_31, ` ${$.get(selectedPhotoIds).length === 0
											? "Download selected"
											: `Download selected (${$.get(selectedPhotoIds).length})`}`);
									});

									$.append($$anchor, div_24);
								};

								$.if(node_34, ($$render) => {
									if ($.get(photoSelectionActive)) $$render(consequent_27);
								});
							}

							$.reset(main_1);
							$.reset(div_7);
							$.reset(div_6);

							var node_36 = $.sibling(div_6, 2);

							{
								var consequent_28 = ($$anchor) => {
									const photos = $.derived(() => $.get(galleryMedia).filter((media) => media.kind === "image"));

									{
										let $0 = $.derived(() => $.get(photos).findIndex((media) => media.id === $.get(selectedMedia).id));
										let $1 = $.derived(() => $.get(model).transferMediaId === $.get(selectedMedia).id ? $.get(model).transferProgress : undefined);
										let $2 = $.derived(() => $.get(model).transferMediaId === $.get(selectedMedia).id ? $.get(model).transferState : undefined);

										PhotoDialog($$anchor, {
											get access() {
												return $.get(selected).access;
											},

											get media() {
												return $.get(selectedMedia);
											},

											get photos() {
												return $.get(photos);
											},

											get photoIndex() {
												return $.get($0);
											},

											get progress() {
												return $.get($1);
											},

											get transferState() {
												return $.get($2);
											}
										});
									}
								};

								var consequent_29 = ($$anchor) => {
									VideoDialog($$anchor, {
										get media() {
											return $.get(selectedMedia);
										},

										get progress() {
											return $.get(model).transferProgress;
										},

										get transferState() {
											return $.get(model).transferState;
										}
									});
								};

								$.if(node_36, ($$render) => {
									if ($.get(selectedMedia)?.kind === "image") $$render(consequent_28); else if ($.get(selectedMedia)?.kind === "video" && $.get(model).videoCapability !== "hidden" && $.get(model).videoCapability !== "disabled-during-session" && $.get(selected).access === "download") $$render(consequent_29, 1);
								});
							}

							$.template_effect(
								($0, $1, $2, $3) => {
									$.set_attribute(button_1, 'aria-label', `Choose album. Current album: ${$.get(selected).label}`);
									$.set_attribute(button_1, 'aria-expanded', $0);
									$.set_text(text_7, $.get(selected).label);
									$.set_text(text_10, $.get(selected).label);
									$.set_attribute(span_9, 'aria-label', $.get(selected).access === "download" ? "Original downloads available" : "View only");
									$.set_text(text_12, $.get(selected).access === "download" ? "Original downloads available" : "View only");
									$.set_text(text_13, $.get(selected).access === "download" ? "Originals" : "View only");
									$.set_text(text_14, $1);

									if (select_value !== (select_value = $.get(model).mediaSort)) {
										(
											select.value = (select.__value = $.get(model).mediaSort) ?? '',
											$.select_option(select, $.get(model).mediaSort)
										);
									}

									$.set_attribute(button_3, 'aria-label', $2);
									$.set_attribute(button_3, 'title', $3);
								},
								[
									() => String($.get(model).shareMenuOpen === true),
									() => $.get(selected).collaboratorFilter === "all"
										? galleryCount($.get(selected).media.length, $.get(selected).totalMediaCount, $.get(selected).hasMore)
										: `${$.get(galleryMedia).length} of ${$.get(selected).media.length} loaded ${itemLabel($.get(selected).media.length)}`,
									() => mediaSortDirectionLabel($.get(model).mediaSort, $.get(model).mediaSortDirection),
									() => mediaSortDirectionLabel($.get(model).mediaSort, $.get(model).mediaSortDirection)
								]
							);

							$.append($$anchor, fragment_4);
						};

						$.if(node_3, ($$render) => {
							if ($.get(selected)) $$render(consequent_30);
						});
					}

					$.append($$anchor, fragment_3);
				};

				$.if(node_1, ($$render) => {
					if ($.get(model).openingShell) $$render(consequent); else if (!$.get(canShowGallery)) $$render(consequent_1, 1); else $$render(alternate_5, -1);
				});
			}

			$.template_effect(() => $.set_text(text, $.get(model).announcement ?? ""));
			$.append($$anchor, fragment_1);
		};

		$.if(node, ($$render) => {
			if ($.get(model)) $$render(consequent_31);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}